(function(){
  var cfg = window.HW || {};
  var TZ = 'America/Chicago';
  var CART_LOGO = cfg.logo || 'https://cdn.shopify.com/s/files/1/1062/3103/8277/files/studio_linton_2_ce44d2b7-7806-4579-a933-12702ec6f491.png?v=1789038893&width=500';

  /* Countdown to midnight US Central, resets every day */
  function secondsLeft(){
    var p = {};
    new Intl.DateTimeFormat('en-US',{timeZone:TZ,hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'})
      .formatToParts(new Date()).forEach(function(x){ if(x.type !== 'literal') p[x.type] = parseInt(x.value,10); });
    var s = 86400 - (p.hour*3600 + p.minute*60 + p.second);
    return s <= 0 ? 86400 : s;
  }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var s = secondsLeft(), h = Math.floor(s/3600), m = Math.floor((s%3600)/60), sec = s%60;
    var timers = document.querySelectorAll('[data-hw-timer]');
    for (var i=0;i<timers.length;i++){
      var t = timers[i];
      var a = t.querySelector('[data-h]'), b = t.querySelector('[data-m]'), c = t.querySelector('[data-s]');
      if (a && a.textContent !== pad(h)) a.textContent = pad(h);
      if (b && b.textContent !== pad(m)) b.textContent = pad(m);
      if (c) c.textContent = pad(sec);
    }
  }
  tick();
  setInterval(tick, 1000);

  /* Click-to-copy discount code */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-hw-code]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var code = btn.getAttribute('data-hw-code');
    var done = function(){ btn.classList.add('is-copied'); setTimeout(function(){ btn.classList.remove('is-copied'); }, 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
  }, true);

  /* Product promo: discount % follows the selected variant */
  function setOff(variantId){
    var promo = document.querySelector('[data-hw-promo]');
    if (!promo) return;
    try {
      var ids = JSON.parse(promo.querySelector('[data-hw-variants]').textContent);
      var offs = JSON.parse(promo.querySelector('[data-hw-offs]').textContent);
      var i = ids.indexOf(Number(variantId));
      if (i < 0) return;
      var off = offs[i] || 0;
      promo.querySelector('[data-hw-off]').textContent = off;
      promo.querySelector('[data-hw-off-wrap]').hidden = off <= 0;
    } catch(err) {}
  }
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    window.subscribe(PUB_SUB_EVENTS.variantChange, function(e){ if (e && e.data && e.data.variant) setOff(e.data.variant.id); });
  }
  document.addEventListener('change', function(e){
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (idInput) setTimeout(function(){ setOff(idInput.value); }, 50);
  });
  var lastId = null;
  setInterval(function(){
    var idInput = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value !== lastId) { lastId = idInput.value; setOff(lastId); }
  }, 700);

  /* Belorin logo in the Kaching cart header */
  function cartLogo(header){
    if (header.querySelector('.hw-cart-logo')) return;
    var img = header.querySelector('img');
    if (img) {
      img.src = CART_LOGO;
      img.removeAttribute('srcset');
      img.classList.add('hw-cart-logo');
      img.alt = 'Belorin';
      return;
    }
    var leaves = header.querySelectorAll('h1,h2,h3,h4,p,span,div');
    for (var k=0;k<leaves.length;k++){
      var el = leaves[k];
      if (el.children.length === 0 && !el.closest('button') && /belorin/i.test(el.textContent)) {
        el.innerHTML = '<span class="hw-cart-logo-wrap"><img class="hw-cart-logo" src="' + CART_LOGO + '" alt="Belorin"></span>';
        return;
      }
    }
  }

  /* Flash Sale text for app widgets (survives re-renders) */
  var BUNDLE_TITLE = 'Flash Sale Deals';
  function inject(){
    var titles = document.querySelectorAll('.kaching-bundles__block-title');
    for (var j=0;j<titles.length;j++){
      if (titles[j].textContent !== BUNDLE_TITLE) titles[j].textContent = BUNDLE_TITLE;
    }
    var header = document.querySelector('.kaching-cart__inner .kaching-cart__header');
    if (header) {
      cartLogo(header);
      if (header.parentNode && !header.parentNode.querySelector('.hw-cart-hello')) {
        var hello = document.createElement('div');
        hello.className = 'hw-cart-hello';
        hello.innerHTML = 'Flash Sale <span>Is Live</span>';
        header.parentNode.insertBefore(hello, header.nextSibling);
      }
    }
  }
  var queued = false;
  function schedule(){ if (queued) return; queued = true; requestAnimationFrame(function(){ queued = false; inject(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
})();